import { AppBreakpointsOptions } from '../IMaterial';

export const initializeBreakpoints = (config?: AppBreakpointsOptions): AppBreakpointsOptions => {
  return {
    ...config,
  };
};
